export default [
  '#341D83',
  '#6EA2F4',
  '#47DFF5',
  '#71D8A3',
  '#FF7383',
  '#FF8065',
  '#C664B6',
  '#493A4A',
  '#046BA1',
  '#46B8F2',
  '#4F527E',
  '#89A3C7',
  '#CB88D5',
  '#EA556A',
  '#E7817F',
  '#FFAC99',
  '#F2B142',
]
